var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBodyproponent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    preserveAspectRatio: "xMidYMax",
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "body_proponent_svg__a",
    d: "M64.824 176.444s129.65 25.014 221.163-79.036l26.219 64.88v23.062l13.641 8.756 16.49 19.936-1.874 19.976-12.777 15.246-20.52 9.581-20.24 33.97-26.535 24.975-34.584 14.346-.587 45.19 13.093 18.02 17.466-23.808 38.022 5.313s52.04 89.837 72.444 84.869c0 0-33.649-285.772 0-288.036 33.65-2.265 1.487-192.938-104.518-170.625C155.72 25.373 132.86-40.917 102.578 53.203c0 0-81.548-34.318-81.235 19.114.313 53.431-46.609 172.133-1.564 208.803 45.045 36.67-.654 180.6-.654 180.6s59.19 3.193 77.516 9.37c18.328 6.178 63.777-109.872 63.777-109.872l-.939-20.876-45.674-25.755-28.408-28.73-7.192-26.815-23.993-3.4-14.616-17.437V214.44l9.888-17.085 14.967-4.378.373-16.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_proponent_svg__c",
    d: "M.537 89.033C.537 40.325 40.025.838 88.74.838H225.84c48.713 0 88.203 39.488 88.203 88.195V215.53H.537V89.033z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_proponent_svg__e",
    d: "M4.36 18.947c-17.707 24.693 25.74 96.454 59.176 95.804 33.436-.65 84.347-75.919 70.507-98.325C120.203-5.98 22.066-5.745 4.36 18.947z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_proponent_svg__g",
    width: 50.166,
    height: 67.238,
    x: 0.469,
    y: 0.455,
    rx: 25.083
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_proponent_svg__i",
    width: 253.072,
    height: 297.496,
    x: 0,
    y: 0,
    rx: 126.536
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_proponent_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_proponent_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M124.368 1.442c12.29-8.949 26.62-7.45 47.374-4.078 20.828 3.384 48.681 7.951 88.687-.47 20.484-4.311 38.412-1.242 53.85 6.647 17.512 8.95 31.832 24.225 42.871 42.248 15.263 24.916 24.246 55.03 27.13 79.872 1.674 14.412 1.273 27.09-.98 36.135-1.293 5.195-3.233 9.31-5.596 12.205-3.021 3.704-6.757 5.68-11.036 5.969-32.909 2.214 5.834 281.013 5.834 281.013s.163 1.174.474 3.366c-1.654 1.836-3.4 3.044-5.24 3.492-19.343 4.71-68.012-69.947-77.696-85.155h0l-31.406-4.388-20.345 27.732-19.396-26.694.668-51.43 37.352-15.494 25.052-23.58 20.78-34.876 21.01-9.81 10.619-12.67 1.446-15.427-14.202-17.172-15.712-10.084v-25.28l-22.016-54.481c-80.071 84.103-184.625 78.116-212.929 74.677h0l-.315 14.02-16.973 4.964-7.777 13.438v19.783l11.592 13.83 25.724 3.644 7.838 29.225 26.616 26.918 47.95 27.04 1.155 25.69-.487 1.254s-20.422 52.107-39.514 84.998c-5.34 9.2-10.623 16.933-15.333 21.845-2.603 2.714-5.118 4.648-7.402 5.783-3.448 1.713-6.608 1.863-9.406.92-17.93-6.045-75.843-9.05-75.843-9.05s-3.193-.166-8.318-.367c1.736-4.95 2.653-7.83 2.653-7.83s20.018-62.94 20.208-115.597c.089-24.382-3.68-46.938-17.527-58.211C1.697 274.524-4.64 255.88-5.848 233.322-7.414 204.12-.5 168.36 5.874 135.765c4.781-24.446 9.264-47.046 9.168-63.411-.284-48.536 62.875-33.333 83.532-27.068 8.382-24.296 16.638-37.178 25.793-43.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    stroke: "#363A4F",
    strokeLinecap: "round",
    strokeWidth: 12.6,
    d: "M124.368 1.442c12.29-8.949 26.62-7.45 47.374-4.078 20.828 3.384 48.681 7.951 88.687-.47 20.484-4.311 38.412-1.242 53.85 6.647 17.512 8.95 31.832 24.225 42.871 42.248 15.263 24.916 24.246 55.03 27.13 79.872 1.674 14.412 1.273 27.09-.98 36.135-1.293 5.195-3.233 9.31-5.596 12.205-3.021 3.704-6.757 5.68-11.036 5.969-32.909 2.214 5.834 281.013 5.834 281.013s.163 1.174.474 3.366c-1.654 1.836-3.4 3.044-5.24 3.492-19.343 4.71-68.012-69.947-77.696-85.155h0l-31.406-4.388-20.345 27.732-19.396-26.694.668-51.43 37.352-15.494 25.052-23.58 20.78-34.876 21.01-9.81 10.619-12.67 1.446-15.427-14.202-17.172-15.712-10.084v-25.28l-22.016-54.481c-80.071 84.103-184.625 78.116-212.929 74.677h0l-.315 14.02-16.973 4.964-7.777 13.438v19.783l11.592 13.83 25.724 3.644 7.838 29.225 26.616 26.918 47.95 27.04 1.155 25.69-.487 1.254s-20.422 52.107-39.514 84.998c-5.34 9.2-10.623 16.933-15.333 21.845-2.603 2.714-5.118 4.648-7.402 5.783-3.448 1.713-6.608 1.863-9.406.92-17.93-6.045-75.843-9.05-75.843-9.05s-3.193-.166-8.318-.367c1.736-4.95 2.653-7.83 2.653-7.83s20.018-62.94 20.208-115.597c.089-24.382-3.68-46.938-17.527-58.211C1.697 274.524-4.64 255.88-5.848 233.322-7.414 204.12-.5 168.36 5.874 135.765c4.781-24.446 9.264-47.046 9.168-63.411-.284-48.536 62.875-33.333 83.532-27.068 8.382-24.296 16.638-37.178 25.793-43.844z",
    mask: "url(#body_proponent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M368.241 188.329s-74 49 3 282l21 1 8-141-32-142z",
    mask: "url(#body_proponent_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.695 65.607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 322.248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_proponent_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_proponent_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F15165",
    stroke: "#363A50",
    strokeWidth: 10.08,
    xlinkHref: "#body_proponent_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79BEAA",
    stroke: "#363A50",
    strokeWidth: 10.08,
    d: "M.537 89.038c0-48.711 39.488-88.2 88.203-88.2H225.84c48.713 0 88.203 39.492 88.203 88.2V225.53H.537V89.038z",
    mask: "url(#body_proponent_svg__d)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 113,
    x: 144,
    y: 94,
    fill: "#000",
    fillOpacity: 0.1,
    mask: "url(#body_proponent_svg__d)",
    rx: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M95.56 19.354S7.495 5.807-1.58 215.974L-65.889 93.347 29.643-28.849l80.898 17.37-14.98 30.833z",
    mask: "url(#body_proponent_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "262.908 143.213 253.834 216.213 254.096 145.92",
    mask: "url(#body_proponent_svg__d)",
    transform: "matrix(1 0 0 -1 0 359.426)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "62.908 143.213 53.834 216.213 54.096 145.92",
    mask: "url(#body_proponent_svg__d)",
    transform: "rotate(180 58.371 179.713)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M285.319 31.545s23.62-48.547 14.894 184.77l38.95-4.211-9.38-164.754L306.51 6.705l-21.191 24.84z",
    mask: "url(#body_proponent_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97 308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_proponent_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_proponent_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#AC718C",
    stroke: "#363A50",
    strokeWidth: 7.56,
    xlinkHref: "#body_proponent_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79BEAA",
    stroke: "#363A50",
    strokeWidth: 7.56,
    d: "M4.36 18.947c-17.707 24.693 25.74 96.454 59.176 95.804 33.436-.65 84.347-75.919 70.507-98.325C120.203-5.98 22.066-5.745 4.36 18.947z",
    mask: "url(#body_proponent_svg__f)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.1,
    mask: "url(#body_proponent_svg__f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 -76)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    y: 0.86,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 10,
    y: 10.863,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 20,
    y: 40.871,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 30,
    y: 55.876,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 40,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 50,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 60,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 70,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 80,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 90,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 100,
    y: 68.379,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 192.555,
    x: 111,
    y: 68.379,
    rx: 2
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M108.77 4.942s50 31-51 117l55-17 28-57 11-49-26-8-17 14z",
    mask: "url(#body_proponent_svg__f)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.428,
    cy: 474.356,
    fill: "#363A50",
    rx: 6.295,
    ry: 6.303
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.428,
    cy: 499.567,
    fill: "#363A50",
    rx: 6.295,
    ry: 6.303
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.428,
    cy: 449.144,
    fill: "#363A50",
    rx: 6.295,
    ry: 6.303
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.512,
    cy: 174.339,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.481,
    cy: 179.261,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.031,
    cy: 174.339,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 176.261,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.575 272.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_proponent_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_proponent_svg__g"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 62.766,
    height: 79.838,
    x: -5.831,
    y: -5.845,
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 31.383
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.062,
    height: 104.628,
    x: -13.928,
    y: -26.549,
    fill: "#F9CCB6",
    mask: "url(#body_proponent_svg__h)",
    rx: 39.031
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M41.167 13.45S30.37 47.657 58.264 65.66C86.16 83.66 52.865 82.76 52.865 82.76L15.972 52.157l-.9-33.305 26.095-5.401z",
    mask: "url(#body_proponent_svg__h)",
    transform: "matrix(-1 0 0 1 84.474 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.995 .38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_proponent_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_proponent_svg__i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#body_proponent_svg__i"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240.472,
    height: 284.896,
    x: 6.3,
    y: 6.3,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    mask: "url(#body_proponent_svg__j)",
    rx: 120.236
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "116 251 136 251 126 260.926",
    mask: "url(#body_proponent_svg__j)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.951,
    cy: 30.884,
    fill: "#F8C4AC",
    mask: "url(#body_proponent_svg__j)",
    rx: 145.422,
    ry: 46.011
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M187.71 72.71s113 58.114 9 196.114l38.043 17 49-186-12-39-34-33-50.043 44.887zM71.71 113.605l-49 25s-12 81 14 126l-49-85-2-64 86-2z",
    mask: "url(#body_proponent_svg__j)"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.03,
    points: "149.962 204.432 160.648 174.899 173.173 206.426 167.943 219.696 156.542 220.739 147.919 214.376"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M242.57 102.278c-6.265-10.853-23.549-12.605-38.604-3.913M78.06 102.278c6.265-10.853 23.55-12.605 38.604-3.913"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.292,
    d: "M146.674 207.931c0 7.457 6.043 13.502 13.497 13.502h0c7.455 0 13.498-6.045 13.498-13.502"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#363A50",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    d: "M105.239 156.623c0-5.468-4.23-9.901-9.449-9.901h0c-5.218 0-9.448 4.433-9.448 9.901"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "matrix(-1 0 0 1 110 140)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29.107,
    x2: 24.607,
    y1: 8.569,
    y2: 12.069
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.373,
    x2: 20.341,
    y1: 2.905,
    y2: 7.733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.111,
    x2: 14.602,
    y1: 0.48,
    y2: 6.158
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.956,
    x2: 7.8,
    y1: 1.722,
    y2: 7.116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.731,
    x2: 5.025,
    y1: 8.544,
    y2: 12.293
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M25.814 166.917c5.371-3.227 12.338-1.494 15.561 3.87h0c3.223 5.364 1.483 12.33-3.888 15.556M279.129 168.878c4.728-4.11 11.89-3.614 15.996 1.11h0c4.106 4.722 3.6 11.884-1.128 15.994"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6.174,
    d: "M134.976 234.035c0 4.971 12.288 9.001 27.445 9.001h0c15.158 0 27.445-4.03 27.445-9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.659,
    cy: 55.923,
    fill: "#F7AEAE",
    opacity: 0.499,
    rx: 23.396,
    ry: 23.404
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.659,
    cy: 55.923,
    fill: "#F7AEAE",
    opacity: 0.499,
    rx: 23.396,
    ry: 23.404
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#363A50",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    d: "M146.761 16.623c0-5.468 4.23-9.901 9.449-9.901h0c5.218 0 9.448 4.433 9.448 9.901"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(142)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29.107,
    x2: 24.607,
    y1: 8.569,
    y2: 12.069
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.373,
    x2: 20.341,
    y1: 2.905,
    y2: 7.733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.111,
    x2: 14.602,
    y1: 0.48,
    y2: 6.158
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.956,
    x2: 7.8,
    y1: 1.722,
    y2: 7.116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.731,
    x2: 5.025,
    y1: 8.544,
    y2: 12.293
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    d: "M320.146 98.937s-112.702 92.5-240.46 92.5c0 0-45.448-104.596 59.629-139.239s180.83 46.739 180.83 46.739z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 10.8,
    d: "M73.829 189.239s174.164-9.033 239.807-87.443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M77.7 182.53S322.344 113.58 293.512 56.47c0 0 32.004 47.469-63.097 84.637C135.313 178.276 77.7 182.53 77.7 182.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M51.757 182.455S278.75 68.093 239.55 17.534c0 0 40.473 40.49-45.789 95.121-86.262 54.631-142.005 69.8-142.005 69.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 60,
    x: 72,
    y: 138,
    fill: "#79BEAA",
    stroke: "#363A4F",
    strokeLinejoin: "round",
    strokeWidth: 6,
    rx: 8,
    transform: "rotate(-30 80 168)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyproponent);
export default __webpack_public_path__ + "static/media/body.proponent.64ed80a8.svg";
export { ForwardRef as ReactComponent };